/* =============================================
   STICKY HEADER JAVASCRIPT - FIXED VERSION
   ============================================= */

(function() {
    'use strict';
    
    // Wait for DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        // Small delay to ensure all elements are rendered
        setTimeout(initStickyHeader, 100);
    });
    
    function initStickyHeader() {
        // Find header
        const header = document.querySelector('.header-classic') || document.querySelector('.header');
        if (!header) {
            console.log('Sticky Header: No header found');
            return;
        }
        
        // Find announcement bar with exact class
        const announcementBar = document.querySelector('.announcement-bar');
        const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
        
        console.log('Sticky Header: Found header', header);
        console.log('Sticky Header: Announcement bar height', announcementHeight);
        
        // Configuration
        const config = {
            enableSticky: true,
            stickyType: 'on-scroll-up',  // 'always' or 'on-scroll-up'
        };
        
        if (!config.enableSticky) return;
        
        const headerHeight = header.offsetHeight;
        let lastScrollY = window.scrollY;
        let isHidden = false;
        
        // Create placeholder to prevent content jump
        const placeholder = document.createElement('div');
        placeholder.className = 'header-sticky-placeholder';
        placeholder.style.cssText = 'height: ' + headerHeight + 'px; display: block;';
        header.parentNode.insertBefore(placeholder, header.nextSibling);
        
        // Apply fixed positioning styles directly
        header.style.cssText += `
            position: fixed !important;
            top: ${announcementHeight}px !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 999 !important;
            transition: transform 0.3s ease, top 0.3s ease, box-shadow 0.3s ease !important;
            background: #fff !important;
        `;
        
        function onScroll() {
            const currentScrollY = window.scrollY;
            
            // Adjust top position based on announcement bar visibility
            if (currentScrollY >= announcementHeight) {
                // Scrolled past announcement bar - stick to very top
                header.style.top = '0px';
                header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
            } else {
                // Announcement bar still visible - position below it
                header.style.top = (announcementHeight - currentScrollY) + 'px';
                header.style.boxShadow = 'none';
            }
            
            // Handle show/hide on scroll direction (only for 'on-scroll-up' type)
            if (config.stickyType === 'on-scroll-up') {
                const scrollThreshold = announcementHeight + headerHeight;
                
                if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
                    // Scrolling DOWN & past threshold - hide header
                    if (!isHidden) {
                        header.style.transform = 'translateY(-100%)';
                        isHidden = true;
                    }
                } else {
                    // Scrolling UP - show header
                    if (isHidden || currentScrollY <= scrollThreshold) {
                        header.style.transform = 'translateY(0)';
                        isHidden = false;
                    }
                }
            }
            
            lastScrollY = currentScrollY;
        }
        
        // Listen to scroll events
        window.addEventListener('scroll', onScroll, { passive: true });
        
        // Initial call
        onScroll();
        
        // Handle window resize (announcement bar height might change)
        window.addEventListener('resize', function() {
            const newAnnouncementHeight = announcementBar ? announcementBar.offsetHeight : 0;
            if (window.scrollY < newAnnouncementHeight) {
                header.style.top = (newAnnouncementHeight - window.scrollY) + 'px';
            }
        }, { passive: true });
    }
})();